import { render, staticRenderFns } from "./tripartiteAgreementForm.vue?vue&type=template&id=50aade32"
import script from "./tripartiteAgreementForm.vue?vue&type=script&lang=js"
export * from "./tripartiteAgreementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports